import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { StoreAuthService } from '@app/core/auth/store-auth.service';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable()
export class UpdateFollowUpService {

  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private storeAuth: StoreAuthService,
    private common: DatabaseCacheService
  ) { }

  updateFollowUp(followUpId: string, followUpPutBody) {
    let sectionId = this.common.getSelectedSection().sectionId;

    // this.storeAuth.getSection().subscribe((value) => {
    //   if (!value) {
    //     this.sectionId = localStorage.getItem('gokuri.sectionId');
    //   } else {
    //     this.sectionId = value;
    //   }
    // });

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    this.headers = this.headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    return this.httpClient.put(`${apiConfig.uri}/licence/${sectionId}/followUp/${followUpId}`, followUpPutBody, { headers: this.headers });
  }
}
